/* Kakucsi-felület: lédig (mérlegen mért) termékek + a kezdőlapi kártyák kosár-gombja.
   Lédig: a címben „lédig” szó (Liquid-párja: snippets/kakucsi-ledig.liquid). 1 egység = 10 dkg, minimum 2 egység.
   A termékoldalon a mennyiségmező alatti „Összesen: 0,6 kg · 3 300 Ft” sort élőben frissíti. */
(function () {
  const LEDIG_PATTERN = /l[eé]dig/i;
  const LEDIG_MIN_UNITS = 2;
  const LEDIG_UNIT_DKG = 10;
  const DKG_PER_KG = 100;

  /** @param {string | undefined | null} title @returns {boolean} */
  function isLedig(title) {
    return LEDIG_PATTERN.test(String(title || ''));
  }

  /** @param {number} units @returns {string} pl. 6 → „0,6 kg” */
  function formatWeight(units) {
    const kg = (units * LEDIG_UNIT_DKG) / DKG_PER_KG;
    return `${kg.toLocaleString('hu-HU', { maximumFractionDigits: 2 })} kg`;
  }

  function groupDigits(cents, decimals, thousandsSep, decimalSep) {
    const [whole, fraction] = (cents / 100).toFixed(decimals).split('.');
    const grouped = whole.replace(/\B(?=(\d{3})+(?!\d))/g, thousandsSep);
    return fraction ? `${grouped}${decimalSep}${fraction}` : grouped;
  }

  const MONEY_FORMATTERS = {
    amount: (c) => groupDigits(c, 2, ',', '.'),
    amount_no_decimals: (c) => groupDigits(c, 0, ',', '.'),
    amount_with_comma_separator: (c) => groupDigits(c, 2, '.', ','),
    amount_no_decimals_with_comma_separator: (c) => groupDigits(c, 0, '.', ','),
    amount_with_space_separator: (c) => groupDigits(c, 2, ' ', ','),
    amount_no_decimals_with_space_separator: (c) => groupDigits(c, 0, ' ', ','),
    amount_with_period_and_space_separator: (c) => groupDigits(c, 2, ' ', '.'),
    amount_with_apostrophe_separator: (c) => groupDigits(c, 2, "'", '.'),
  };

  /** A bolt pénzformátuma (shop.money_format) szerint; ismeretlen formátumnál magyar forint. */
  function formatMoney(cents, format) {
    const match = String(format || '').match(/\{\{\s*(\w+)\s*\}\}/);
    const formatter = match && MONEY_FORMATTERS[match[1]];
    if (!formatter) return `${groupDigits(cents, 0, ' ', ',')} Ft`;
    return format.replace(match[0], formatter(cents));
  }

  /** Termékoldal: „Összesen: <súly> · <ár>” a mennyiségmező aktuális értékéből. */
  function refreshLive(live) {
    const form = live.closest('.product-form__quantity');
    const input = form && form.querySelector('.quantity__input');
    const total = live.querySelector('[data-kk-ledig-total]');
    const unitPrice = Number(live.dataset.kkUnitPrice);
    if (!input || !total || !Number.isFinite(unitPrice)) return;
    const units = Math.max(parseInt(input.value, 10) || 0, 0);
    const text = `${formatWeight(units)} · ${formatMoney(unitPrice * units, live.dataset.kkMoneyFormat)}`;
    if (total.textContent !== text) total.textContent = text;
  }

  function refreshAllLive(root) {
    (root || document).querySelectorAll('[data-kk-ledig-live]').forEach(refreshLive);
  }

  function initLedigProductPage() {
    const forms = document.querySelectorAll('.product-form__quantity');
    if (!forms.length) return;
    refreshAllLive();
    ['input', 'change'].forEach((type) =>
      document.addEventListener(type, (evt) => {
        const form = evt.target.closest && evt.target.closest('.product-form__quantity');
        if (form && evt.target.matches('.quantity__input')) refreshAllLive(form);
      })
    );
    /* A Dawn variánsváltáskor / kosárfrissítéskor átírja a mennyiség-szabályokat (és az értéket) → újraszámolás.
       Csak eltérő szövegnél írunk, így a megfigyelő nem hurkol. */
    const observer = new MutationObserver(() => refreshAllLive());
    forms.forEach((form) => observer.observe(form, { childList: true, subtree: true }));
    /* A Dawn constants.js / pubsub.js globális (nem window-) kötései; setQuantityBoundries értékírása után jelez. */
    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
      subscribe(PUB_SUB_EVENTS.quantityUpdate, () => refreshAllLive());
    }
  }

  window.kakucsiLedig = Object.freeze({ isLedig, formatWeight, formatMoney, MIN_UNITS: LEDIG_MIN_UNITS });

  /* DOMContentLoaded-kor már minden defer-szkript (product-info.js is) lefutott, így a mező értéke végleges. */
  let ledigStarted = false;
  function startLedig() {
    if (ledigStarted) return;
    ledigStarted = true;
    initLedigProductPage();
  }
  document.addEventListener('DOMContentLoaded', startLedig);
  window.addEventListener('load', startLedig);
  if (document.readyState === 'complete') startLedig();

  /* Kezdőlapi kártyák kosár-gombja (egyszerű, opció nélküli termékek).
     A Shopify saját /cart/add.js végpontját hívja, a fejléc kosár-ikonját a Dawn cart-icon-bubble szekciójával frissíti. */
  const TOAST_MS = 4000;
  const BUBBLE_SECTION = 'cart-icon-bubble';
  let toastTimer;

  function toast(message, isError) {
    let el = document.querySelector('.kk-toast');
    if (!el) {
      el = document.createElement('div');
      el.className = 'kk-toast';
      el.setAttribute('role', 'status');
      el.setAttribute('aria-live', 'polite');
      document.body.appendChild(el);
    }
    el.textContent = '';
    const text = document.createElement('span');
    text.textContent = message;
    el.appendChild(text);
    if (!isError) {
      const link = document.createElement('a');
      link.className = 'kk-toast__action';
      link.href = (window.routes && window.routes.cart_url) || '/cart';
      link.textContent = 'Kosár';
      el.appendChild(link);
    }
    el.classList.toggle('is-error', Boolean(isError));
    el.classList.add('is-visible');
    clearTimeout(toastTimer);
    toastTimer = setTimeout(() => el.classList.remove('is-visible'), TOAST_MS);
  }

  function updateBubble(sections) {
    const html = sections && sections[BUBBLE_SECTION];
    const target = document.getElementById('cart-icon-bubble');
    if (!html || !target) return;
    const section = new DOMParser().parseFromString(html, 'text/html').querySelector('.shopify-section');
    if (section) target.innerHTML = section.innerHTML;
  }

  async function addToCart(button) {
    const id = Number(button.dataset.kkAdd);
    const name = button.dataset.kkName || 'Termék';
    const ledig = isLedig(button.dataset.kkTitle || button.dataset.kkName);
    const quantity = ledig ? LEDIG_MIN_UNITS : 1;
    button.disabled = true;
    button.classList.add('is-loading');
    try {
      const res = await fetch(((window.routes && window.routes.cart_add_url) || '/cart/add') + '.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: [{ id, quantity }], sections: BUBBLE_SECTION, sections_url: window.location.pathname }),
      });
      const data = await res.json();
      if (!res.ok || data.status) throw new Error(data.description || data.message || 'Nem sikerült kosárba tenni.');
      updateBubble(data.sections);
      toast(`Kosárba tettük: ${name}${ledig ? ` (${quantity * LEDIG_UNIT_DKG} dkg)` : ''}`);
    } catch (err) {
      console.error('[kakucsi] kosárba tétel', err);
      toast(err.message || 'Nem sikerült kosárba tenni, próbáld újra.', true);
    } finally {
      button.disabled = false;
      button.classList.remove('is-loading');
    }
  }

  document.addEventListener('click', (evt) => {
    const button = evt.target.closest('[data-kk-add]');
    if (!button || button.disabled) return;
    evt.preventDefault();
    addToCart(button);
  });
})();
